import type { ReactNode } from "react";
import { useBooth } from "./BoothContext";
import { IconBack, IconHome } from "@/features/admin/components/icons";
import { Badge } from "@/components/ui";

/** Persistent booth chrome: chronological back and explicit start-over controls. */
export function BoothChrome({ preview }: { preview: boolean }) {
  const booth = useBooth();

  const showNav = booth.screen !== "welcome" && booth.screen !== "processing";

  return (
    <>
      {showNav && (
        <div className="absolute inset-x-0 top-0 z-20 flex items-center justify-between p-5">
          <ChromeButton label="Back" onClick={booth.goBack}>
            <IconBack size={20} />
          </ChromeButton>
          <ChromeButton label="Start over" onClick={booth.restart}>
            <IconHome size={20} />
          </ChromeButton>
        </div>
      )}

      {preview && (
        <div className="absolute right-5 top-5 z-20">
          <Badge tone="aqua">Preview</Badge>
        </div>
      )}

    </>
  );
}

function ChromeButton({ label, onClick, children }: { label: string; onClick: () => void; children: ReactNode }) {
  return (
    <button
      onClick={onClick}
      aria-label={label}
      className="grid h-12 w-12 place-items-center rounded-full bg-black/25 text-white/85 backdrop-blur-sm transition-colors active:bg-black/40"
    >
      {children}
    </button>
  );
}

